import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { ChartDataSets, ChartOptions } from 'chart.js';
import { Color} from 'ng2-charts';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss']
})
export class BarChartComponent implements OnInit, OnChanges {
  @Input() barsData: any[]
  lineChartData: ChartDataSets[] = [];
  lineChartLabels: Array<any> = [];
  lineChartOptions: any = {
    responsive: true,
    legend: {
      display: true
    },
    scales: {
      yAxes: [{id: 'y-axis-1', type: 'linear', position: 'left', ticks: {min: 0, max: 5},
      scaleLabel: {display: true, labelString: 'Ratings'}}],
      xAxes: [{scaleLabel: {display: true, labelString: 'Date'} }]
    },
    maintainAspectRatio: false
  };
  lineChartLegend = true;
  lineChartType = 'bar';
  public lineChartPlugins = [];
  public lineChartColors: Color[] = [];
  constructor() { }

  drawChart = true;
  ngOnInit() {
  }

  ngOnChanges() {

    if(!this.drawChart){
      return;
    }
    this.setLineData();
    this.drawChart = false;
    setTimeout(() => {
       this.drawChart = true;
     }, 500)
  }

  setLineData() {
    console.log('this.barsData', this.barsData);
    this.lineChartData = [];
    this.barsData.forEach((lineData: any) => {
      console.log('lineData', lineData);
      this.lineChartData.push({label: lineData.title, data: lineData.data});
    });
    if (this.barsData && this.barsData.length) {
      this.lineChartLabels = this.barsData[0].labels;
    }
  }
}
